import { addSlashToOriginPath } from '../utils';

const CONFIG_KEY = 'NEWRON_PLATFORM_CONFIG';

type Config = {
  AUTH0_DOMAIN: string;
  BASE_URL: string;
  MFE_UPSELL_HAS_BANNERS: boolean;
};

function getConfig(): Config {
  const config = window[CONFIG_KEY] || {};

  return {
    AUTH0_DOMAIN: config['AUTH0_DOMAIN'] || '',
    BASE_URL: addSlashToOriginPath(window.location.origin),
    MFE_UPSELL_HAS_BANNERS: config['MFE_UPSELL_HAS_BANNERS'] || true,
  };
}

export { getConfig, CONFIG_KEY, Config };
